<template>
  <validation-observer v-slot="{ invalid }" ref="step1">
  <b-form ref="productForm" @submit.prevent="formSubmitted" @change="formChanged()">
    <b-row>
      <b-col md="6">
        <b-form-group label="Product Name" label-for="mc-Product-name">
          
          <validation-provider
          rules="required"
          #default="{ errors }"
          name="Product Name"
        >
          <b-form-input
            id="mc-Product-name"
            placeholder="Product Name"
            v-model="Product.name"
          />
          <small v-if="errors.length" class="text-danger text-end">{{
            errors[0]
          }}</small>
        </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Product Classification" label-for="mc-Product-name">
          <b-form-select v-model="Product.type" :options="productTypes" />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="mc-stock-threshold" label="Unit Of Measure">
          <div class="form-label-group">
            <b-form-select
              id="mc-Product-Code"
              placeholder="Product Code"
              v-model="Product.uomid"
              :options="itemUomList"
              @change="setUOM"
              value-field="id"
            text-field="name"
            />
          </div>
        </b-form-group>
      </b-col>
        
      <b-col md="2">
        <b-form-group label="Enable Ecommerce" label-for="mc-Product-Ecomm">
          <b-form-checkbox
            checked="false"
            v-model="Product.isEcomm"
            name="check-button"
            switch
            inline
          >
          </b-form-checkbox>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group label="Product Code" label-for="mc-Product-Code">
          <b-form-input
            id="mc-Product-Code"
            placeholder="Product Code"
            v-model="Product.code"
          />
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Barcode" label-for="mc-Barcode">
          <b-form-input
            id="mc-Barcode"
            type="text"
            placeholder="Barcode"
            v-model="Product.barcode"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="mc-stock-threshold" label="Low Stock Threshold">
          <div class="form-label-group">
            <validation-provider v-slot="{ errors }" name="Low Stock Threshold" rules="min_value:0">
            <b-form-input
              id="mc-stock"
              type="text"
              placeholder="Low Stock Threshold"
              v-model="Product.lowStock"
            />
            <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Category" label-for="mc-Category">
          <b-form-select
            v-model="Product.categoryID"
            :options="parentCategoryList"
            value-field="id"
            text-field="name"
            @change="fetchCategoryDetails(Product.categoryID)" 
          />
        </b-form-group>
      </b-col>
       <b-col cols="6">
        <b-form-group :disabled="Product.categoryID != null" label="Sub Category" label-for="mc-subCategory">
          <b-form-select
            v-model="Product.productCategorySubId"
            :options="subCategoryList"
            value-field="id"
            text-field="name"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group label="Preferred Supplier" label-for="mc-Supplier">
          <b-form-select
            v-model="Product.supplierId"
            :options="supplierList"
            value-field="id"
            text-field="name"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" class="mb-2">
        <label for="textarea-default">Product Description</label>
        <b-form-textarea
          id="textarea-default"
          placeholder="Product Description"
          rows="5"
          v-model="Product.description"
        />
      </b-col>
      <b-col cols="3">
        <label v-b-tooltip.hover.focus.v-secondary
        title="Note: Disabling a product means all current stock will be sent to scrap." for="textarea-default">Enable/Disable Product </label>
        <b-form-checkbox
            checked="true"
            name="check-button"
            v-model="Product.isActive"
            switch
          >
            {{ Product.isActive ? 'Enabled' : 'Disabled' }}
          </b-form-checkbox>
      </b-col>
      <b-col cols="9">
        <b-form-group label="Upload / Edit Image">
          <b-form-file
            id="file-input"
            ref="fileInput"
            @change="onFileChange"
            placeholder="Upload an image..."
            class="col-10"
            accept=".jpg, .jpeg, .png"
          ></b-form-file>
          <div v-if="errorMessage.length > 0" class="error-message text-danger">{{ errorMessage }}</div>
          <b-button
            @click="clearImage"
            variant="danger"
            class="mt-1 mx-2"
            v-if="uploadedImage"
            >Clear Image</b-button
          >
        </b-form-group>

        <b-card-text title="Product Image" v-if="Product.productImage || uploadedImage">
          <img v-if="uploadedImage" :src="uploadedImage" width="250" height="250" />
          <img v-else :src="'data:image/jpeg;base64,' + Product.productImage" width="250" height="250" />
        </b-card-text>
        <b-button
            @click="removeExistingImage"
            variant="danger"
            class="mt-1"
            v-if="Product.productImage && !uploadedImage"
            >Remove</b-button>
      </b-col>
    </b-row>
    
    <CustomFieldsDetails :AdditionalFields="Product.additionalFields" :ModuleReference="'Product'" @onchange="additionalFieldChanges"></CustomFieldsDetails>
  </b-form>
</validation-observer>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormTextarea,
  BFormSelect,
  BFormFile,
  BCardText,
  VBTooltip,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import CustomFieldsDetails from "@/views/component/CustomFieldsDetails.vue";
import { fnSortingDropdown, customError, customSwal } from "@/libs/customFn";

export default {
  components: {
    BRow,
    BFormSelect,
    BCol,
    ToastificationContent,
    BFormFile,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BFormTextarea,
    BButton,
    BCardText,
    ValidationProvider,
    ValidationObserver,
    CustomFieldsDetails,
    VBTooltip,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  props: {
    Product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      uploadedImage: null, // Add this to hold the new image data
      uploadedFile: null,
      productTypes: [
        { value: 1, text: "Finished" },
        { value: 2, text: "Semi Finished" },
      ],
      parentCategoryList: [],
      subCategoryList:[],
      supplierList:[],
      errorMessage: "",
      additionalFields:[
        {
          ordering: 0,
          fieldName: null,
          fieldValue: null,
          fieldType: "text",
          isRequired: false,
          displayEcomm: false,
        }
      ],
     
    };
    
  },
  methods: {
    async fetchCategoryDetails(id) {
      this.subCategoryList = await this.getItemSubCategoryListAction(id);

      this.subCategoryList = fnSortingDropdown(
        this.subCategoryList,
        "asc",
        "name"
      );
    },
    async formValidation(){
      let stepValidation = await this.$refs.step1.validate();
      return stepValidation;
    },
    setSubCategory(){
      this.subCategoryList = this.itemCategories.filter((x) => x.isSub && x.parentId == this.Product.categoryID);
    },
    onFileChange(e) {
    let file = e.target.files[0];
    if (!file) return;

    // File validation (size and type)
    const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    const fileExtension = file.name.split('.').pop().toLowerCase();

    if (!validTypes.includes(file.type) || !['jpg', 'jpeg', 'png'].includes(fileExtension)) {
      this.errorMessage = "Only JPG, JPEG, and PNG files are allowed.";
      this.clearImage(); // Clear file input and state
      this.cancelUpload();
      return;
    }

    // Create image
    this.createImage(file);
  },

  createImage(file) {
    let reader = new FileReader();
    reader.onload = (e) => {
      this.uploadedImage = e.target.result;
      this.uploadedFile = file;
      this.formChanged();
    };
    reader.readAsDataURL(file);
  },

  clearImage() {
    this.uploadedImage = null;
    this.uploadedFile = null;
    this.$refs.fileInput.value = "";
  },
  cancelUpload() {
      // Find the file input element and reset its value
      this.details.file = null;
      this.imageSrc = null;
      //this.$refs["file-input"].reset();
      this.$refs.fileInput.value = "";
    },

  removeExistingImage() {
    this.Product.productImage = "__removed__";
    this.uploadedFile = "__removed__";
    this.formChanged();
  },
    additionalFieldChanges(customFields){
      this.Product.additionalFields = customFields;
    },
    formSubmitted() {
      this.$router.push("/product/list/");
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Product Successfully Added",
          icon: "EditIcon",
          variant: "success",
        },
      }),
        this.$bvModal.hide("modal-1");
    },
    ...mapActions("itemUomModule", ["getItemUOMListAction"]),
    ...mapActions("itemcategoryModule", ["getItemCategoryListAction", "getItemSubCategoryListAction"]),
    ...mapActions("supplierModule", ["getSupplierListAction"]),
    formChanged() {
      this.$emit("onchange", { product: this.Product, uploadedFile: this.uploadedFile });
    },
    checkUomId() {
      this.Product.uomid = this.Product.defaultUomId;
      if (!this.Product.uomid) {
        let uom = this.itemUoms.filter((obj) => {
          return obj.name === this.Product.uomName;
        });
        if (uom.length > 0) {
          this.Product.uomid = uom[0].id;
        }
      }
    },
  },

  computed: {
    ...mapGetters("itemUomModule", {
      itemUoms: "itemuom",
      loading: "loading",
    }),
    ...mapGetters("itemcategoryModule", {
      itemCategories: "itemcategories",
      loading: "loading",
    }),
    ...mapGetters("supplierModule", {
      suppliers: "suppliers",
      loading: "loading",
    }),
  },
  async mounted() {
    if(this.Product.categoryID != null) await this.fetchCategoryDetails(this.Product.categoryID);

    await this.getItemUOMListAction().then(() => {
      this.checkUomId();
      this.itemUomList = fnSortingDropdown(this.itemUoms, "asc", "name");
    });
    await this.getItemCategoryListAction().then(() => {
      console.log("itemCategories", this.itemCategories);
      this.parentCategoryList = fnSortingDropdown(
        this.itemCategories.filter((x) => !x.isSub),
        "asc",
        "name"
      );
    });
    await this.getSupplierListAction().then(() => {
      this.supplierList = fnSortingDropdown(this.suppliers, "asc", "name");
    });
  },
};
</script>
